import React from 'react';
import Container from 'Nori/Container';
import Button from 'Nori/Button';
import styles from 'Custom/ActionStrip/index.module.scss';

const ActionStrip = ({
  title = '',
  className = '',
  designModuleNo = '00',
  buttonLabel = '',
  buttonHref = '/',
  children,
  ...props
}) => {
  return (
    <div
      className={`${styles.actionStrip} ${className}`}
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Inline Content"
      data-design-module_name={title}
      data-design-module_no={designModuleNo}
      {...props}
    >
      <Container className={styles.actionStripContainer}>
        <div className={styles.actionStripContent}>
          <span className={styles.actionStripTitle}>{title}</span>
        </div>
        {buttonLabel && (
          <Button
            type="secondary2"
            size="small"
            href={buttonHref}
            target="_blank"
            rel="noopener"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label={buttonLabel}
            data-design-nori_id="Inline Content"
            data-design-module_name={title}
            data-design-module_no={designModuleNo}
            className={styles.actionStripButton}
          >
            {buttonLabel}
          </Button>
        )}
      </Container>
    </div>
  );
};

export default ActionStrip;
